import { Trans } from '@lingui/react/macro';

import {
  useFormToolTemplates,
  type FormToolTemplate,
} from '../lib/formToolTemplates';

export interface FormToolTemplatesProps {
  onSelect: (template: FormToolTemplate) => void;
}

export function FormToolTemplates({ onSelect }: FormToolTemplatesProps) {
  const formToolTemplates = useFormToolTemplates();

  return (
    <div className='grid gap-3 sm:grid-cols-2 lg:grid-cols-4'>
      {formToolTemplates.map(template => (
        <button
          key={template.id}
          type='button'
          className='rounded-radius border border-border p-4 text-left transition hover:border-primary hover:bg-muted/30'
          onClick={() => onSelect(template)}
        >
          <div className='font-medium'>{template.label}</div>
          <p className='mt-1 text-sm text-muted-fg'>{template.description}</p>
        </button>
      ))}
    </div>
  );
}

export function FormToolTemplatesSection({ onSelect }: FormToolTemplatesProps) {
  return (
    <div className='space-y-3'>
      <div>
        <h3 className='text-sm font-medium'>
          <Trans>Start from a template</Trans>
        </h3>
        <p className='text-sm text-muted-fg'>
          <Trans>
            Templates pre-fill fields and suggested tool settings. You can edit
            everything before saving.
          </Trans>
        </p>
      </div>
      <FormToolTemplates onSelect={onSelect} />
    </div>
  );
}
